export default "__VITE_PUBLIC_ASSET__8578b8da__"